import React from "react";
import { useNavigate } from "react-router-dom";
import NewDexterLogo from "../../Images/NewDexterLogo.svg";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Dexter_Splash2 } from "../../Routes";
import "../../style/Main.scss";

const WelcomePage = () => {
  const Navigate = useNavigate();

  const HandleSubmit = () => {
    Navigate(Dexter_Splash2);
  };
  return (
    <div className="container-fluid">
      <header className = "navbar">
        <img alt="" src={NewDexterLogo} className="Navbar-img" />
      </header>
      <div className="container">
        <span className="text">World's first Passive only</span>
        <span className="text">
          <span className="sub-text">Wealth</span> Tech Platform
        </span>

        <span className="bottom-text">
          Access High Performing passive portfolios.
        </span>

        <div className="btn-container">
          <button className="btn-submit" onClick={HandleSubmit}>
            Begin <KeyboardArrowRightIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomePage;
